// hooks/useOfflineClass.js
import { useEffect, useState } from "react";

export default function useOfflineClass() {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isPWA = () => {
      return (
        window.matchMedia('(display-mode: standalone)').matches || // Chrome, Edge, Opera
        window.matchMedia('(display-mode: minimal-ui)').matches || // Some mobile browsers
        window.navigator.standalone || // iOS Safari
        document.referrer.includes('android-app://') // Android TWA
      );
    };

    const checkForBuildUpdate = async () => {
      try {
        // Only do the full update check in PWA mode
        if (isPWA() && 'serviceWorker' in navigator) {
          console.log("PWA mode: checking for updates...");
          const registration = await navigator.serviceWorker.ready;
          await registration.update();
          
          const newWorker = registration.installing || registration.waiting;
          
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                console.log('New service worker activated, reloading...');
                window.location.reload();
              }
            });
            
            if (newWorker.state === 'waiting') {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          }
        }
      } catch (err) {
        console.error("Update check failed:", err);
      }
    };

    // Run check if online
    if (navigator.onLine) {
      checkForBuildUpdate();
    }

    const updateStatus = () => {
      const offline = !navigator.onLine;
      setIsOffline(offline);

      if (typeof document !== "undefined") {
        document.body.classList.toggle("offline", offline);
      }

      // Check for updates when coming back online
      if (!offline) {
        checkForBuildUpdate();
      }
    };

    updateStatus();

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return isOffline;
}
